import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Socket } from 'ng-socket-io';
import { Router } from '@angular/router';
import { AlertasModales } from '../../helpers/alertasModales';
// Servicio
import { EmpleadosServicio } from '../../services/empleado.service';
import { RutasService } from '../../services/rutas.service';
import { Helper } from '../../helpers/helper';
import { Subscription } from 'rxjs/Subscription';
import { TimerObservable } from 'rxjs/observable/TimerObservable';
import { ReportesService } from '../../services/reportes.service';
import { environment } from '../../../environments/environment.prod';
// tslint:disable-next-line:import-blacklist

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  datosEmpleado: any;
  rutasAsignadas = [];
  actividades = [];
  companias = [];
  recordatorios = [];
  ptmPendientes = [];
  animatePtm = false;
  presolicitudes = [];
  animatePreSolicitudes = false;
  notificacionesCount = 0;
  recordatoriosCount = 0;
  private audioPresolicitudes = new Audio('./assets/sounds/notification-solicitud.mp3');
  private audioPtmPendientes = new Audio('./assets/sounds/notification-loan.mp3');
  public notificationsPath = `/assets/sounds/`;
  dateNow = new Date(this.helper.getDate());
  private subscription: Subscription;
  private modalIsOpen = false;
  dropdownPtmOpen = false;
  dropdownPSolicitudesOpen = false;
  private modalRef: any;
  securityToken = localStorage.getItem('token');
  compania: string;
  constructor(
    public empleadoService: EmpleadosServicio,
    private socket: Socket,
    private router: Router,
    private modals: AlertasModales,
    private rutaService: RutasService,
    public helper: Helper,
    private reportesService: ReportesService
    ) {
    this.datosEmpleado = this.empleadoService.datosEmpleado;
    this.initActividades();
    this.initRecordatorios();
    this.initRutas();
    this.initPtmPendientes();
    this.initPresolicitudes();
  }

  ngOnInit() {
    this.initTimerPtm();
    this.initSockets();
    this.initCompanias();
  }

  ngAfterViewInit() {
    setTimeout(() => localStorage.removeItem('recordatorio'), 1000);
  }

  private initRutas() {
    this.rutaService.cargarRutasAsignadas(this.datosEmpleado.ID_EMPLEADO).subscribe(rutas => {
      if (rutas.rutas) {
        this.socket.on('actividades', (res) => {
          if (parseFloat(res.compania) === this.helper.compania) {
            if (
              (rutas.rutas.filter(item => item.ID_RUTA === res.ID_RUTA).length > 0  ||
              this.datosEmpleado.tipo_empleado === 3) &&
              res.ID_TIPO_ACTIVIDAD !== 47
              ) {
              const audio = new Audio();
              $('#activity-log').removeClass('animated flash');
              this.actividades.unshift(res);
              this.notificacionesCount++;
              $('#activity-log').addClass('animated flash');

              switch (res.ID_TIPO_ACTIVIDAD) {
                case 16:
                audio.src = `${this.notificationsPath}notificacion-recibo.mp3`; // Recibos
                break;
                case 24:
                audio.src = `${this.notificationsPath}notificacion-notas.mp3`; // nota
                break;
                case 48:
                case 49:
                  audio.src = `${this.notificationsPath}notification-activity.mp3`;
                  for (let i = 0; i < this.presolicitudes.length; i++) {
                    if (parseFloat(this.presolicitudes[i].ID) === parseFloat(res.ID)) {
                      this.presolicitudes.splice(i, 1);
                    }
                  }
                break;
                default:
                audio.src = `${this.notificationsPath}notification-activity.mp3`; // nota
              }
              audio.load();
              audio.play();

            } else if (res.ID_TIPO_ACTIVIDAD === 47) {
              this.presolicitudes.unshift(res);
              this.animatePreSolicitudes = true;
              this.audioPresolicitudes.play();
            }
          }
        });
      }
    });
  }

  private initActividades(): void {
    // Cargar actividades
    this.empleadoService.cargarActividades().subscribe((res: any) => {
      this.actividades = res;

      this.actividades.map(item => {
        if (item.abierto === 0) {
          this.notificacionesCount++;
        }
      });
    });
  }

  private initSockets(): void {
    this.socket.connect();
    this.socket.on('prestamo_aprobado', (data) => {
      if (parseFloat(data.compania) === this.helper.compania) {
        for (let i = 0; i < this.ptmPendientes.length; i++) {
          if (this.ptmPendientes[i].ID_PRESTAMO === parseFloat(data.ID_PRESTAMO)) {
            this.ptmPendientes.splice(i, 1);
          }
        }
      }
    });

    this.socket.on('prestamo_denegado', (data) => {
      if (parseFloat(data.compania) === this.helper.compania) {
        for (let i = 0; i < this.ptmPendientes.length; i++) {
          if (this.ptmPendientes[i].ID_PRESTAMO === parseFloat(data.ID_PRESTAMO)) {
            this.ptmPendientes.splice(i, 1);
          }
        }
      }
    });

    this.socket.on('prestamo_pendiente', (data) => {
      console.log(data);
      if (parseFloat(data.compania) === this.helper.compania) {
        this.ptmPendientes.unshift(data);
        const audio = new Audio('./assets/sounds/notification-activity3.mp3');
        audio.play();
      }
    });
  }

  private initPtmPendientes(): void {
    this.empleadoService.prestamosPendiente()
    .subscribe((res: any) => {
      this.ptmPendientes =  res;
    });
  }

  private initPresolicitudes(): void {
    this.empleadoService.preSolicitudesPendiente()
    .subscribe((res: any) => {
      this.presolicitudes =  res;
    });
  }

  private initTimerRecordatorios(): void {
    const timer = TimerObservable.create(0, 1000);
    this.subscription = timer.subscribe(t => {
      for (const row of this.recordatorios) {
        if (new Date(row.fecha_recordatorio) <= new Date(this.helper.getDate()) && row.recordar === 'NO') {
          row.recordar = 'SI';
          this.recordatoriosCount++;
        }
      }

      // if (this.modalIsOpen) {
      //   this.modalRef.componentInstance.recordatorios.unshift(arr);
      //   this.modalRef.result.then(() => {
      //     this.initRecordatorios(false);
      //     // this.modalIsOpen = false;
      //   });
      // } else {
      //   console.log('No Open');
      //   this.openModalRecordatorios(true);
      // }
    });
  }

  private openModalRecordatorios(abrirModal = true): void {
    const recordatoriosEmpleado = this.recordatorios.filter(
      // tslint:disable-next-line:max-line-length
      (data) => data.completado === 0 &&
      data.ID_EMPLEADO === this.datosEmpleado.ID_EMPLEADO &&
      new Date(data.fecha_recordatorio) <= new Date(this.helper.getDate())
    );
    if (this.recordatoriosCount > 0 && abrirModal && recordatoriosEmpleado.length > 0) {
      this.modalIsOpen = true;
      this.modalRef = this.modals.recordatorios(recordatoriosEmpleado);
      this.modalRef.result.then(() => {
        this.initRecordatorios(false);
        this.modalIsOpen = false;
      });
    }
  }

  private initRecordatorios(abrirModal = true): void {
    this.empleadoService.cargarRecordatorios().subscribe((res: any) => {
      this.recordatorios = res.recordatorios;
      this.recordatoriosCount = res.total_recordatorios;
      // this.initTimerRecordatorios();

      if (!localStorage.getItem('recordatorio')) {
        this.openModalRecordatorios(abrirModal);
      }
    });
  }


  abrirNotificaciones() {
    this.empleadoService.abrirNotificaciones().subscribe(res => {
      if (res === 'OK') {
        this.notificacionesCount = 0;
      }
    });
  }

  abrirActividad(actividad: any) {
    this.empleadoService.abrirActividad(actividad).subscribe(res => {
      if (res === 'OK') {
        actividad.leido = 1;
        switch (actividad.ID_TIPO_ACTIVIDAD) {
          case 4:
          case 5:
          case 6:
          case 8:
          case 13:
          case 14:
          case 15:
          case 24:
          case 33:
          case 34:
          case 35:
          case 41:
          case 42:
          case 45:
          case 46:
            this.router.navigate(['/prestamo', actividad.ID]);
          break;
          case 7:
          case 3:
            this.router.navigate(['/ruta', actividad.ID]);
          break;
          case 1:
          case 9:
          case 10:
          case 11:
          case 12:
          case 23:
          case 26:
          case 59:
            if (actividad.ID) {
              this.router.navigate(['/cliente', actividad.ID]);
            }
          break;
          case 16:
            this.router.navigate(['/lista/recibos'], { queryParams: { r: actividad.ID } });
          break;
          case 17:
          case 18:
          case 20:
          case 21:
          case 36:
          case 39:
          case 57:
            this.router.navigate(['/lista/apertura-dia']);
          break;
          case 19:
            this.router.navigate(['/lista/gastos-dietas']);
          break;
          case 22:
            this.router.navigate(['/configurar/prestamos']);
          break;
          case 48:
          case 49:
          case 50:
            this.router.navigate(['/lista/pre-solicitudes-prestamos'], { queryParams: { pre: actividad.ID } });
          break;
        }
      }
    });
  }

  private initTimerPtm(): void {

    const timer = TimerObservable.create(10000, 15000);
    timer.subscribe(t => {
      if (this.ptmPendientes.length) {
        this.animatePtm = true;
        this.audioPtmPendientes.play();
        this.audioPtmPendientes.onended = () => this.animatePtm = false;
      }

      if (this.presolicitudes.length) {
        this.animatePreSolicitudes = true;
        this.audioPresolicitudes.play();
        this.audioPresolicitudes.onended = () => this.animatePreSolicitudes = false;
      }
    });
  }

  navigate(item) {
    this.router.navigate(['/lista/pre-solicitudes-prestamos'], { queryParams: { pre: item.ID } });
  }

  private initCompanias() {
    this.reportesService.companias().subscribe((res: any[]) => {
      this.companias = res;
      this.compania = res.filter(row => row.ID_COMPANIA == this.helper.compania)[0].descripcion || '';
    });
  }

  ngOnDestroy() {
    this.audioPresolicitudes = new Audio();
    this.audioPtmPendientes = new Audio();
    this.dropdownPtmOpen = false;
    this.dropdownPSolicitudesOpen = false;
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/header/header.component.ts